import { TextBox, TextBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { getPercentOfApprovedAmount } from './functions/getPercentOfApprovedAmount';

/** Read-only: Broker Share as a percent of Apprvd Loan Amt. */
export const BrokerSharePercentField = () => {
    const brokerShare = useStandardLoanStore((state) => state.loan.brokerShare);
    const commitment = useStandardLoanStore((state) => state.loan.commitment);

    return (
        <TextBox
            id='loanBrokerSharePercent'
            value={getPercentOfApprovedAmount(brokerShare, commitment)}
            onChange={() => undefined}
            label='Broker Share %'
            disabled={true}
            width='100%'
            height='36px'
            layoutStyle={TextBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
